"use strict";
// _partialFile.js

{
  const swiper = new Swiper(".p-topOurJob__swiper", {
    //swiperの名前
    //切り替えのモーション
    speed: 1000, //表示切り替えのスピード
    effect: "slide", //切り替えのmotion (※1)
    allowTouchMove: true, // スワイプで表示の切り替えを有効に

    //最後→最初に戻るループ再生を有効に
    loop: true,
    //自動スライドについて
    autoplay: {
      delay: 3000, //何秒ごとにスライドを動かすか
      stopOnLastSlide: false, //最後のスライドで自動再生を終了させるか
      disableOnInteraction: true, //ユーザーの操作時に止める
      reverseDirection: false, //自動再生を逆向きにする
    },

    //表示について
    centeredSlides: true, //中央寄せにする
    slidesPerView: "auto",

    //ナビゲーション
    navigation: {
      prevEl: ".swiper-button-prev", //戻るボタンのclass
      nextEl: ".swiper-button-next", //進むボタンのclass
    },
  });
  const swiper2 = new Swiper(".p-topInterview__swiper", {
    //swiperの名前
    //切り替えのモーション
    speed: 1000, //表示切り替えのスピード
    effect: "slide", //切り替えのmotion (※1)
    allowTouchMove: true, // スワイプで表示の切り替えを有効に

    //最後→最初に戻るループ再生を有効に
    loop: true,

    //表示について
    centeredSlides: false, //中央寄せにする
    // slidesPerView: "auto",
    // spaceBetween: 85,
    //ブレイクポイントによって変える
    //自動スライドについて
    autoplay: {
      delay: 3000, //何秒ごとにスライドを動かすか
      stopOnLastSlide: false, //最後のスライドで自動再生を終了させるか
      disableOnInteraction: true, //ユーザーの操作時に止める
      reverseDirection: false, //自動再生を逆向きにする
    },

    breakpoints: {
      375: {
        slidesPerView: "auto",
        spaceBetween: 40,
      },
      520: {
        slidesPerView: "auto",
        spaceBetween: 85,
      },
    },

    //ナビゲーション
    navigation: {
      prevEl: ".swiper-button-prev", //戻るボタンのclass
      nextEl: ".swiper-button-next", //進むボタンのclass
    },
  });

  swiper;

  /* =================================================== 
    // 下層ページのスライダー
======================================================= */
  // about
  const swiper3 = new Swiper(".p-lowerAbout__brand__swiper", {
    //swiperの名前
    //切り替えのモーション
    speed: 1000, //表示切り替えのスピード
    effect: "slide", //切り替えのmotion (※1)
    allowTouchMove: true, // スワイプで表示の切り替えを有効に

    //最後→最初に戻るループ再生を有効に
    loop: true,
    //自動スライドについて
    autoplay: {
      delay: 3000, //何秒ごとにスライドを動かすか
      stopOnLastSlide: false, //最後のスライドで自動再生を終了させるか
      disableOnInteraction: true, //ユーザーの操作時に止める
      reverseDirection: false, //自動再生を逆向きにする
    },

    //表示について
    centeredSlides: true, //中央寄せにする
    slidesPerView: "auto",

    //ナビゲーション
    navigation: {
      prevEl: ".swiper-button-prev", //戻るボタンのclass
      nextEl: ".swiper-button-next", //進むボタンのclass
    },
  });
  // work-single
  const swiper4 = new Swiper(".p-entry-work__swiper", {
    //swiperの名前
    //切り替えのモーション
    speed: 1000, //表示切り替えのスピード
    effect: "slide", //切り替えのmotion (※1)
    allowTouchMove: true, // スワイプで表示の切り替えを有効に

    //最後→最初に戻るループ再生を有効に
    loop: true,
    //自動スライドについて
    autoplay: {
      delay: 3000, //何秒ごとにスライドを動かすか
      stopOnLastSlide: false, //最後のスライドで自動再生を終了させるか
      disableOnInteraction: true, //ユーザーの操作時に止める
      reverseDirection: false, //自動再生を逆向きにする
    },

    //表示について
    centeredSlides: true, //中央寄せにする
    slidesPerView: "auto",

    //ナビゲーション
    navigation: {
      prevEl: ".swiper-button-prev", //戻るボタンのclass
      nextEl: ".swiper-button-next", //進むボタンのclass
    },
  });

  /* =================================================== 
※1 effectについて
slide：左から次のスライドが流れてくる
fade：次のスライドがふわっと表示
■ fadeの場合は下記を記述
  fadeEffect: {
    crossFade: true
  },
cube：スライドが立方体になり、3D回転を繰り返す
coverflow：写真やアルバムジャケットをめくるようなアニメーション
flip：平面が回転するようなアニメーション
cards：カードを順番にみていくようなアニメーション
creative：カスタマイズしたアニメーションを使うときに使用します

=======================================================
※2 paginationのタイプ
bullets：スライド枚数と同じ数のドットが表示
fraction：分数で表示（例：1 / 3）
progressbar：スライドの進捗に応じてプログレスバーが伸びる
custom：自由にカスタマイズ

=====================================================*/
}
